'use strict';
import {notify, notifyPersistent} from "../events/notify";
import {inputText, fileList, inputSelect} from "./inputs";
import {div, span, button, empty, icon, input, makeElement} from "../utils/makeElement";




//Create a complete upload handler
// get it's element with `item.element` and append it to DOM.
//It creates it's own hierarchy internally
// handler() cb should match the signature of uploadHandler widget : (file, destRef, meta)
export default class NewItem{
  constructor(handler, scope){
    this._scope = scope ||window.clientScope;

    this.ready = false;
    //Handler to call when an upload should take place
    this.handler = handler;
    //The input element is not really presented to user and is just a local proxy to the browser's file handling method
    this.input = makeElement("input",{
      type: "file",
      multiple: true,
      accept: "video/*",
      onchange: this.handleFileChosen.bind(this)
    });

    //A function used to set selected files names
    this.setFilenames = fileList({title: "selected files"});
    this._filenames = [];
    //start upload : this.handleUpload.bind(this);
    this.reset();
  }
  get element(){
    return this._el;
  }
  get form(){ //alias for this.element;
    return this.element;
  }
  get(id){
    return ((this.form)? this.form[id] : null );
  }

  set filenames(arr){
    //Store actual input value;
    this._filenames = arr;
    try { //setFilenames does type-check arr.
      this.setFilenames(arr);
    }catch(e){
      console.error(e);
    }
  }
  get filenames() { return this._filenames; }
  //Various form-values getters which are just wrappers around this.get()
  get format()      { return this.get("format-select").value; }
  get encoding()    { return this.get("encode-select").value; }
  get project_name(){ return this.get("project-name").value;  }

  get scope(){ return this._scope; }

  handleFileOpenRequest(){
    console.log("OpenRequest");
    //"forward" the event to the internal <input>
    var evt = document.createEvent("MouseEvents");
    evt.initEvent("click", true, false);
    this.input.dispatchEvent(evt);
  }
  handleFileChosen(e){
    const list = this.input.files;
    console.log("File(s) chosen : ", list);
    if (! list[0]){
      this.element.classList.remove("has-file", 'has-multiple-files');
      this.filenames = [];
      return
    }else if(1< list.length){
      //Apply class for multiple selection
      this.element.classList.add("has-file", "has-multiple-files");
    }else{
      this.element.classList.add("has-file");
      this.element.classList.remove("has-multiple-files");
    }

    const files = Array.from(list);
    this.filenames = files.map(f => f.name);
  }

  handleUpload(e){
  const files = this.input.files;
    if (!files[0]){
      return; // No-op if no file is selected. This should never even be triggered
    }
    if(1 < files.length){
      if(this.project_name){
        notify("warn",`Can not customize project name when uploading multiple files`);
        return
      }
      notify("info",`Uploading ${files.length} files`);
    }
    for(let idx=0; idx < files.length; idx++){
      this.startUpload(files[idx]);
    }
    this.reset();
  }

  startUpload(file){
    let ext = file.name.slice(file.name.lastIndexOf("."));
    let name = (this.project_name)?this.project_name:file.name;
    if( name.slice(- ext.length) !== ext){
      //Users will often provide a file name without extension
      name = name+ext;
    }
    let meta = {
      customMetadata:{
        scope: this.scope,
        format: this.format,
        encoding: this.encoding,
        contentType: file.type
      }
    };
    this.handler(file, name, meta);
  }
  // create a `makeUploaderElement()` and auto-replace it on reset
  //BUG if reset() is called when elem is not inserted BUT someone has a reference to it, it's desynchronized
  reset(){
    //re-create widget and reattach to parent if necessary
    let old_el = this._el;
    this._el = this.render();
    if(old_el && old_el.parentNode){
      old_el.parentNode.replaceChild(this._el, old_el);
    }
    return this._el;
  }
  //Create an uninserted input element to trigger file chooser dialog
  // Get it later using `NewItem.element`
  // elements get shown/hidden depending if a file is selected or not
  // any future call to render should reset everything except for current uploads.
  render(){
    // Allow selection of videos format
    let format_select = inputSelect({
      title:"format",
      id:"format-select",
      children : ["native", "pixel", "opalh", "opalv"]
    });

    //Encoding selection
    const encoding_select = inputSelect({
      title:"encoding",
      id:"encode-select",
      children: ["encode", "keep"]
    });
    //Change project name if desired
    const project_name_input = inputText({
      id: "project-name",
      className: "hover-raise focus-raise hide-no-files hide-multiple",
      title: "project's name",
      description: "leave empty to keep original file's name",
      input:{placeholder: "project name"}
    })

    // Main element. I's important for it to be aform so we can query it's named children
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/namedItem
    return makeElement("form",{
      className: "new-item",
      onsubmit:function(e){e.preventDefault();return false;}
    }, div(
      {
        className:"create form-group",
        id:"create-new-content"
      }, [
        // File selector proxy. triggers a "click" on <input>
        button({
          id:"file-select-button",
          className: "button button-accent hover-raise show-no-files",
          onclick : this.handleFileOpenRequest.bind(this)
        }, [
          icon("open", {fill:"#FFFFFF", className:"button-icon"}),
          span("Choose a file")
        ]),

        //A group shown only when at least one file is selected
        //Show a resettable list of selected files
        div({className:"form-group hide-no-files"},[
          this.setFilenames(this.filenames), //This function returns the actual HTMLElement
          button({ //reset icon
            id:"reset-files",
            type: "button",
            role: "reset",
            className:"button button-exponent button-accent",
            style:{marginLeft:"-16px"},
            onclick: ()=>{
              this.reset();
            }
          }, icon("delete", {className:"button-icon"})),
        ]),

        //Format, encoding and name selection
        div({className:"form-group hide-no-files"},[
          format_select,
          encoding_select,
          project_name_input
        ]),

        //Final send button
        button({
          id:"file-send-button",
          type: "submit",
          role: "submit",
          className: "button hover-raise disable-no-files",
          onclick: this.handleUpload.bind(this)
        }, [
          icon("upload", {className: "button-icon"}),
          span("Send")
        ])
      ]
    ));
  }
}
